"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentTransferTotal = exports.getAvailableAccountMoneyForPayment = void 0;
const roundMoney_1 = require("../../../utils/roundMoney");
const getAvailableAccountMoneyForPayment = (options) => {
    const { balance, creditLimit, allWithheldMoney } = options;
    const result = balance + (creditLimit !== null && creditLimit !== void 0 ? creditLimit : 0) + (allWithheldMoney !== null && allWithheldMoney !== void 0 ? allWithheldMoney : 0);
    return (0, roundMoney_1.roundMoney)(result);
};
exports.getAvailableAccountMoneyForPayment = getAvailableAccountMoneyForPayment;
const getPaymentTransferTotal = (options) => {
    const { balance, creditLimit, priceToPay, partialPayment, allWithheldMoney, payByAccount } = options;
    const min = (...args) => (Math.min(...args.filter((x) => x !== undefined)));
    const availableAccountMoney = (0, exports.getAvailableAccountMoneyForPayment)({
        balance,
        creditLimit,
        allWithheldMoney,
    });
    const accountPayment = payByAccount ? availableAccountMoney : undefined;
    const result = min(partialPayment, accountPayment, priceToPay);
    return (0, roundMoney_1.roundMoney)(result);
};
exports.getPaymentTransferTotal = getPaymentTransferTotal;
//# sourceMappingURL=utils.js.map